const AppSettings = {
    appTitle: 'MuseMinded',
    apiUrl: 'https://api.gemini.museminded.com/api/v1',
    wsUrl: 'wss://api.gemini.museminded.com/cable',
    dateRegex: '(^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$)|^($)',
    yearMonthRegex: '(^[0-9]{4}-(0[1-9]|1[0-2])$)|^($)',
    baseHref: 'https://gemini.museminded.com/', // TODO: Check this before deployment in production
    amazonApplicationId: 'amzn1.sp.solution.e6519c08-23c6-4f57-a23d-c1b6ff28f71c', // TODO : Check before deployment in production
    redirectUri: 'https://api.gemini.museminded.com/api/v1/amazon_connections/oauth_callback' // TODO : Check before deployment in production

};

if (process.env.NODE_ENV === 'development') {
    AppSettings.apiUrl = 'http://localhost:4000/api/v1';
    AppSettings.wsUrl = 'ws://localhost:4000/cable';
    AppSettings.baseHref = 'http://localhost:3000/';
    AppSettings.amazonApplicationId = 'amzn1.sp.solution.e6519c08-23c6-4f57-a23d-c1b6ff28f71c';
    AppSettings.redirectUri = 'https://api.feature.museminded.com/api/v1/amazon_connections/oauth_callback';
} else if (process.env.NODE_ENV === 'staging') {
    AppSettings.apiUrl = 'https://api.staging.museminded.com/api/v1';
    AppSettings.wsUrl = 'wss://api.staging.museminded.com/cable';
    AppSettings.baseHref = 'https://staging.museminded.com/';
} else if (process.env.NODE_ENV === 'feature') {
    AppSettings.apiUrl = 'https://api.feature.museminded.com/api/v1';
    AppSettings.wsUrl = 'wss://api.feature.museminded.com/cable';
    AppSettings.baseHref = 'https://feature.museminded.com/';
    AppSettings.amazonApplicationId = 'amzn1.sp.solution.e6519c08-23c6-4f57-a23d-c1b6ff28f71c';
    AppSettings.redirectUri = 'https://api.feature.museminded.com/api/v1/amazon_connections/oauth_callback';
} else if (process.env.NODE_ENV === 'test') {
    AppSettings.apiUrl = '/api/v1';
    AppSettings.wsUrl = 'wss://api.feature.museminded.com/cable';
    AppSettings.baseHref = '/';
}

export default AppSettings;

